var UtilRecipes = /** @class */ (function () {
    function UtilRecipes() {
        this.isPlayerQualifiedToProduceWithRecipe = function (recipeData, playerLevel) {
            var requiredLevelForRecipe = recipeData.recipe.requLevel || 0;
            return playerLevel >= requiredLevelForRecipe;
        };
        this.getMaxRecipeAmount = function (recipe) {
            return recipe ? recipe.recipe.maxStackSize || 1 : 1;
        };
    }
    return UtilRecipes;
}());
export var utilRecipes = new UtilRecipes();



//////////////////
// WEBPACK FOOTER
// ./src/utils/utilRecipes.ts
// module id = 2251
// module chunks = 3